import { useEffect, useState } from 'react'
import { istVeraltet, VERALTET } from './Fassung'
import { t } from './sprache'

/**
 * **Die Seite sagt, dass sie veraltet ist** (7.2 Abschnitt 46, R1441) — oben
 * im Arbeitsfeld, mit dem Knopf zum Neuladen. Bis dahin ist Speichern
 * gesperrt.
 */
export function Fassungshinweis() {
  const [veraltet, setVeraltet] = useState(istVeraltet())

  useEffect(() => {
    const melde = () => setVeraltet(true)
    window.addEventListener(VERALTET, melde)
    return () => window.removeEventListener(VERALTET, melde)
  }, [])

  if (!veraltet) {
    return null
  }

  return (
    <div className="meldung" role="alert">
      <span>{t('fassung.veraltet')}</span>{' '}
      <button type="button" onClick={() => window.location.reload()}>
        {t('fassung.neuladen')}
      </button>
    </div>
  )
}
